var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapsulesDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 454,
    viewBox: "0 0 478 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443.555,
    height: 105.621,
    rx: 52.8105,
    transform: "matrix(0.741475 -0.67098 0.64375 0.765236 0 297.616)",
    fill: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 411.598,
    height: 98.0115,
    rx: 49.0057,
    transform: "matrix(0.741475 -0.67098 0.64375 0.765236 109.715 378.587)",
    fill: "#F0F2F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsulesDown);
export default __webpack_public_path__ + "static/media/capsules-down.852e9b2623d8fd4bc928c9b1f7d0476b.svg";
export { ForwardRef as ReactComponent };